export const SET_ALL_CARD_STACKS = 'PRO/SET_ALL_CARD_STACKS'
export type SET_ALL_CARD_STACKS = typeof SET_ALL_CARD_STACKS
